import React from 'react'

import {getGlobalStore} from "../../state/globalStore"
import ReactTooltip from "react-tooltip"

export default class ClickableIcon extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hovered: false,
      mouseDown: false
    }
  }

  getFlattenedProps() {
    // remove the extra value layer which appears in props when used in ag-grid
    return this.props.value && this.props.value.iconPath !== undefined ? this.props.value : this.props
  }

  handleOnClick() {
    const props = this.getFlattenedProps()
    if (props.disabled) {
      return
    }
    if (props.actionType) {
      getGlobalStore().dispatch({type: props.actionType, payload: props.data})
    }
    if (props.actionFunction) {
      props.actionFunction()
    }
    if (props.toolTipText) {
      setTimeout(() => ReactTooltip.rebuild())
    }
  }

  handleHover(hovered) {
    const props = this.getFlattenedProps()
    if (props.toolTipText) {
      setTimeout(() => ReactTooltip.rebuild())
    }

    // reduce unnecessary setState triggering since it seems to cause issues when embedded in the grid
    if (props.hoverIconPath) {
      this.setState({hovered: hovered})
    }
  }

  handleMouseDownUp(isDown) {
    const props = this.getFlattenedProps()
    if (props.activeIconPath) {
      // below odd code is work-around for disappearing icon issue when in the grid
      // which can be reproduced in WatchListTest.java
      this.mouseDown = isDown
      this.setState({mouseDown: isDown})
    }
  }

  render() {
    const props = this.getFlattenedProps()
    let imageSource = this.state.hovered && props.hoverIconPath || props.iconPath
    if (this.mouseDown && props.activeIconPath) {
      imageSource = props.activeIconPath
    }
    if (!imageSource) {
      return null
    }

    let imageClass = "icon-image"

    if (props.disabled) {
      const idx = props.iconPath.search(".svg")
      imageSource = props.iconPath.substr(0, idx) + '-disabled.svg'
      imageClass = "icon-image-disabled"
    }

    if (props.additionalClass) {
      imageClass += ' ' + props.additionalClass
    }

    let iconStyle = {height: 33, width: 33}
    let imgStyle = null
    if (this.props.iconSize) {
      iconStyle = {height: this.props.iconSize, width: this.props.iconSize}
      imgStyle = iconStyle
    }

    return (
        <div className="icon-outside"
             onMouseEnter={this.handleHover.bind(this, true)}
             onMouseLeave={this.handleHover.bind(this, false)}
             onMouseDown={this.handleMouseDownUp.bind(this, true)}
             onMouseUp={this.handleMouseDownUp.bind(this, false)}>
          <div data-tip={props.toolTipText} data-for="n2c3-tooltip"
               className={props.buttonClassName}
               onClick={this.handleOnClick.bind(this)}>
            <div className={imageClass} style={iconStyle}>
              <img id={props.imgId} style={imgStyle} alt={props.toolTipText} src={imageSource}/>
            </div>
          </div>
        </div>
    )
  }
}